var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96387 16.7041C13.5107 16.7041 17.168 13.0469 17.168 8.5C17.168 3.95315 13.5107 0.295898 8.96387 0.295898C4.41702 0.295898 0.759766 3.95315 0.759766 8.5C0.759766 13.0469 4.46644 16.7041 8.96387 16.7041Z",
    fill: "#2CB5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16909 8.45059C4.16909 8.45059 8.27115 6.77024 9.7044 6.17717C10.248 5.93006 12.0767 5.18872 12.0767 5.18872C12.0767 5.18872 12.9168 4.84277 12.8674 5.68295C12.8674 6.0289 12.6697 7.16561 12.472 8.45059C12.1755 10.2298 11.879 12.1573 11.879 12.1573C11.879 12.1573 11.8296 12.7009 11.4342 12.7998C11.0388 12.8986 10.3469 12.4538 10.248 12.355C10.1492 12.3055 8.46883 11.2182 7.87576 10.6746C7.7275 10.5263 7.52981 10.2298 7.87576 9.93326C8.71594 9.14251 9.75381 8.20348 10.3469 7.56099C10.6434 7.26446 10.94 6.62197 9.75382 7.41273C8.07346 8.54944 6.3931 9.68615 6.3931 9.68615C6.3931 9.68615 5.99773 9.93326 5.30581 9.68615C4.6139 9.48846 3.77372 9.19193 3.77372 9.19193C3.77372 9.19193 3.23007 8.79655 4.16909 8.45059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.73d04d26e8a3d7be21f01221aca50958.svg";
export { ForwardRef as ReactComponent };